import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 16px;
  svg {
    min-width: 20px;
  }
  border-bottom: 1px solid rgb(225, 235, 254);
`;

export const Title = styled.h6`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0;
  flex: 1 1 0%;
`;

export const IconContainer = styled.div`
  height: 20px;
  svg {
    color: ${COLOR.LAVENDER_GRAY};
  }
`;
